const config = {
baseURL: process.env.REACT_APP_API_BASE_URL || 'https://pharma-outlet.com/api',
// baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api',
};

export default config;
